import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { Factura } from 'src/app/Models/factura/factura';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { Cuota } from 'src/app/Models/cuota/cuota';
import { DatePipe } from '@angular/common';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { Guia } from 'src/app/Models/guia/guia';
import { ArticuloDialogComponent } from '../../articulo/articulo-dialog/articulo-dialog.component';
import { ComprasArticuloComponent } from '../../compras/compras-detcompra/compras-detcompra.component';
import * as moment from 'moment';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { Numero } from 'src/app/Models/numero/numero';
import { Moneda } from 'src/app/Models/moneda/moneda';
import { AuthService } from 'src/app/Service/auth.service';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { ClienteDialogComponent } from '../../cliente/cliente-dialog/cliente-dialog.component';
import { TipoDocumento } from 'src/app/Models/tipodocumento/tipo-documento';
import { ClienteEditComponent } from '../../cliente/cliente-edit/cliente-edit.component';
import { Articulo } from 'src/app/Models/articulo/articulo';

@Component({
  selector: 'app-add-factura',
  templateUrl: './add-factura.component.html',
  styleUrls: ['./add-factura.component.css']
})
export class AddFacturaComponent implements OnInit {
  public funcion: Function;
  public isShow: boolean = false;
  public factura: Factura = new Factura()
  public cliente: Cliente = new Cliente()
  public fechaHoraActual: Date;
  public cuotas: Cuota[] = [];
  public guias: Guia[] = [];
  public detfactus: DetalleFactura[] = [];
  public tipdetraccion: any[] = [];
  public tipooperaciones: any[] = [];
  public numcuotas: number = 0;
  public monedas: Moneda[] = [];
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  expandedStates: boolean[] = [false, false, false];
  public serie_boleta: Numero = new Numero();
  public serie_factura: Numero = new Numero();
  public usuario: Usuario = new Usuario();
  public tipodocumentos: TipoDocumento[] = [];
  @ViewChild('btnshowFactura', null) btnshowFactura: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('artloading', null) artloading: LoadingComponent;
  @ViewChild('artinfo', null) artinfo: InfoComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(ArticuloDialogComponent, null) newarticulo: ArticuloDialogComponent;
  @ViewChild(ClienteDialogComponent, null) newcliente: ClienteDialogComponent;
  @ViewChild(ClienteEditComponent, null) public fmclienteedit: ClienteEditComponent;
  @ViewChildren('icon0, icon1, icon2, icon3') icons: QueryList<ElementRef>;


  constructor(private data: DataService, private notify: NotifyService, private datepipe: DatePipe, private auth: AuthService) {
    this.fechaHoraActual = new Date();
    this.usuario = this.auth.getCurrentUser();
  }

  ngOnInit() {

  }

  public show(affterfunction: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    this.cliente.documento = '1';
    this.factura.moneda = 'PEN';
    this.factura.estado = 'EMI';
    this.factura.documen = 'BOL';
    this.factura.clasepago = 'CON';
    this.factura.tipo_ope = '01';
    this.factura.diasletras = '0';
    this.factura.tcambio = '1';
    this.factura.igv = 18;
    this.factura.fecha = moment(this.fechaHoraActual).format('YYYY-MM-DD');
    setTimeout(async () => {
      this.btnshowFactura.nativeElement.click();
      this.artloading.show('Cargando datos');
      console.log(this.factura.fecha);
      this.GetTipoDetracciones();
      this.GetTipo_Ope();
      this.getTipoDocumento();
      this.GetMonedas();
      //this.PrepararData();
      this.artloading.hide();
      console.log("mostrando series");
      console.log(this.serie_boleta);
      console.log(this.serie_factura);
    }, 10);
  }

  GetMonedas() {
    this.data.GetSimple(this.data.api.moneda).subscribe(r => {
      this.monedas = r;
    })

  }

  getTipoDocumento() {

    this.data.GetSimple(this.data.api.tipodocumento).subscribe(r => {
      try {
        this.tipodocumentos = r;
      } catch (ex) { console.log(ex); }
    });
  }

  GetTipoDetracciones() {
    this.data.GetSimple(this.data.api.detraccion).subscribe(r => {
      this.tipdetraccion = r;
      console.log(this.tipdetraccion);

    })
  }
  GetTipo_Ope() {
    this.data.GetSimple('tipo_ope').subscribe(r => {
      this.tipooperaciones = r;
    })
  }

  async GetCliente() {
    console.log("buscando cliente");
    await this.data.AsyncGetFromValue(this.data.api.cliente, 'documento', this.cliente.documento).then(async r => {
      console.log(r);

      if (r.length < 1) {
        console.log("buscando en sunat");
        await this.data.Consulta('ruc', this.cliente.documento).then(r => {
          console.log(r);
          if (r.result != 0 && r.message.razon_social != null) {
            this.cliente.nombre = r.message.razon_social
            this.cliente.direccion = r.message.domicilio_fiscal

          } else {
            console.log(r.message);
            this.data.notify("Usuario no encontrado", "Error", this.alertType.warning, this.options);

          }
        }).catch(e => { this.data.notify("Usuario no encontrado", "Error", this.alertType.warning, this.options) });
      } else {
        console.log(r);
        this.cliente = r[0];
        this.factura.idcliente = this.cliente.idcliente

      }
    }, e => {
      this.data.notify("Usuario no encontrado", "Error", this.alertType.error); console.log(e);
    })
  }

  gettipofac(){
    switch (this.factura.documen) {
      case 'BOL':
        this.serie_boleta = this.data.getSerieBoleta();
        this.factura.serie = this.serie_boleta.serie
        break;
      case 'FAC':
        this.serie_factura = this.data.getSerieFactura();
          this.factura.serie = this.serie_factura.serie
          break;
      default:
        break;
    }
  }

  AddCuota() {
    let newcuota: Cuota = new Cuota();
    newcuota.nrocuota = (this.numcuotas++).toString();
    newcuota.fecha = this.datepipe.transform(this.fechaHoraActual, 'dd-MM-yyy');
    newcuota.total = 0.00;
    this.cuotas.push(newcuota);
  }

  UpdateCuota(index: number, field: string, value: string) {
    this.cuotas[index][field] = value;
  }

  DeleteCuota() { this.cuotas.pop(); }

  showaddcliente() {
    
    document.getElementById('frmfactura').style.overflow = 'auto';
    document.body.style.overflow = 'auto';

    this.fmclienteedit.cliente = new Cliente();
    this.fmclienteedit.iseditable = false;
    this.fmclienteedit.clientedirecciones = [];
    this.fmclienteedit.show(() => { 
      document.getElementById('frmfactura').style.overflow = 'auto';
      document.body.style.overflow = 'auto';
      this.cliente=this.fmclienteedit.cliente;
     });
  }

  showcuotas() {
    console.log(this.cuotas);
  }
  mostrarcliente() {
    document.getElementById('frmfactura').style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    this.newcliente.cliente = new Cliente()
    this.newcliente.show(() => {
      document.getElementById('frmfactura').style.overflow = 'auto';
      document.body.style.overflow = '';
      console.log("exito");
      this.cliente = this.newcliente.cliente;
    })
  }

  close() {
    this.detfactus = [];
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow=false; }, 1000);
    setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
  }

  CalcularDetfactu(index: number) {
    const item = this.detfactus[index];

    if (item.afectoigv === '6') {
      item.igv = '0.00'
      item.valorunit = item.preuni
      item.valgratui = (+item.valorunit * +item.cantidad).toFixed(2);
    } else {
      item.igv = (this.factura.igv).toString()
      !item.valorunit ?
        item.valorunit = (+item.preuni / (1 + (+item.igv / 100))).toFixed(2) :
        item.preuni = (+item.valorunit * (1 + (+item.igv / 100))).toFixed(2);
      ;
      item.valgratui = '0.00'
    }
    item.impto_cbp === '1' ? item.icbp = (+item.cantidad) * 0.4 : item.icbp = 0
    item.totdscto = (+item.valorunit * +item.cantidad * (+item.descuento / 100)).toFixed(2);
    item.impneto = ((+item.valorunit * +item.cantidad) - (+item.totdscto)).toFixed(2);
    item.igvi = (((+item.valorunit * +item.cantidad) - (+item.totdscto)) * (+item.igv / 100)).toFixed(2);
    item.impnetoct = ((+item.impneto) + (+item.igvi)).toFixed(2)
  }

  CalcularDetracciones() {

  }

  onDetraccionChange(selectedItem: any) {
    if (selectedItem) {
      this.factura.dtr_cod_bien = selectedItem.codigo;
      this.factura.dtr_porcien = selectedItem.porcien;
    } else {
      this.factura.dtr_cod_bien = null;
      this.factura.dtr_porcien = null;
    }
    this.factura.dtr_monto = this.factura.totalfactu * (this.factura.dtr_porcien / 100)
  }

  CalcularRetenciones() {
    switch (+this.factura.retporcien) {
      case 1:
        this.factura.tot_reten = this.factura.totalfactu * 0.03
        break;
      case 2:
        this.factura.tot_reten = this.factura.totalfactu * 0.04
        break;
      default:
        this.factura.tot_reten = 0
        break;
    }
  }

  AddDetfactu() {
    document.getElementById('frmfactura').style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    this.newarticulo.articulo= new Articulo()
    this.newarticulo.show(() => {


      document.getElementById('frmfactura').style.overflow = 'auto';
      document.body.style.overflow = '';
      if (this.newarticulo.articulo.idproduct!=undefined && this.newarticulo.precio.preventa!=undefined) {

        let newdetalle: DetalleFactura = new DetalleFactura();
        newdetalle.articulo = this.newarticulo.articulo;
        newdetalle.idproduct = this.newarticulo.articulo.idproduct;
        newdetalle.preuni = this.newarticulo.precio.preventa;
        newdetalle.cantidad=this.newarticulo.cantidad.toString();
        newdetalle.afectoigv = this.newarticulo.articulo.afectoigv;
        newdetalle.impto_cbp = this.newarticulo.articulo.impto_cbp;
        newdetalle.descuento = '0.00'
        this.detfactus.push(newdetalle);

        this.CalcularDetfactu(this.detfactus.length - 1)
        this.CalcularSumas();

      }else{
        console.log("articlo no sleccionado");
      }

      
    });

  }

  UpdateDetfactu(index: number, field: string, value: string) {
    this.detfactus[index][field] = value;
    if (field === 'preuni' || field === 'valorunit' || field === 'cantidad' || field === 'descuento') {
      this.CalcularDetfactu(index);

    }

  }

  DeleteDetfactu(index: number) {
    this.detfactus.splice(index, 1);
    this.CalcularSumas();
  }

  AddGuia() {
    let newguia: Guia = new Guia();

    newguia.guia_serie = '';
    newguia.guia_numero = '';
    this.guias.push(newguia);
  }

  DeleteGuia() { this.guias.pop(); }

  UpdateGuia(index: number, field: string, value: string) {
    this.guias[index][field] = value;
  }


  getTotal(): number {
    return this.detfactus.reduce((total, detalle) => total + parseFloat(detalle.impnetoct), 0);
  }

  CalcularSumas() {
    this.factura.valorvta = 0
    this.factura.igvt = 0
    this.factura.impinafec = 0
    this.factura.impnogrv = 0
    this.factura.totaldscto = 0
    this.factura.totgratui = 0
    this.factura.tot_icbp = 0

    this.detfactus.forEach(detfactu => {
      switch (detfactu.afectoigv) {
        case '1':

          this.factura.valorvta = this.factura.valorvta + (+detfactu.impneto);
          console.log(this.factura.valorvta);
          this.factura.igvt = this.factura.igvt + (+detfactu.igvi);
          break;
        case '9' || '16':

          this.factura.impinafec = this.factura.impinafec + (+detfactu.impneto);
          break;
        case '8':
          this.factura.impnogrv = this.factura.impnogrv + (+detfactu.impneto);
          break;
        default:
          break;
      }
      this.factura.totaldscto = this.factura.totaldscto + (+detfactu.totdscto);
      this.factura.totgratui = this.factura.totgratui + (+detfactu.valgratui);
      detfactu.impto_cbp == '1' ? this.factura.tot_icbp = +detfactu.icbp : detfactu.impto_cbp;
    });

    this.factura.total = (+(this.factura.valorvta + this.factura.impinafec + this.factura.impnogrv + this.factura.igvt).toFixed(2))
    this.factura.totalfactu = (+(this.factura.total + this.factura.tot_icbp).toFixed(2));
  }

  GuardarNumero(idnumero: any, numero: Numero) {
    numero.ultimo = (+numero.ultimo + 1)
    this.data.Put(this.data.api.numero, idnumero, numero).subscribe(r => {
      if (r.status != "success") {
        console.log(r);
      }
    }), (e => console.log(e))
  }

  GuardarGuia(guia:Guia) {
    this.data.Post(this.data.api.guia, guia).subscribe(r => {
    }), e => { };
  }

  GuardarCuota(cuota:Cuota) {
    this.data.Post(this.data.api.cuota, cuota).subscribe(r => {
    }), e => { };
  }

  PrepararData() {

    this.factura.apellidos = this.cliente.nombre;
    this.factura.ruc = this.cliente.documento;
    this.factura.direccion = this.cliente.direccion
    this.factura.idcliente = this.cliente.idcliente
    this.factura.idsucursal = 1
    this.factura.idvende = this.usuario.idpersonal.idpersonal
    this.factura.tip_iden = this.cliente.tipodocide
    this.CalcularSumas();
    switch (this.factura.documen) {
      case 'BOL':
        this.serie_boleta = this.data.getSerieBoleta();
        this.factura.documen = 'BOL'
        this.factura.serie = this.serie_boleta.serie
        this.factura.numero = this.factura.numero ? this.factura.numero : (+this.serie_boleta.ultimo + 1)
        this.factura.total && this.detfactus.length > 0 ? this.GuardarNumero(this.serie_boleta.idnumero, this.serie_boleta) : null;
        break;
      case 'FAC':
        this.serie_factura = this.data.getSerieFactura();
        this.factura.documen = 'FAC'
        this.factura.serie = this.serie_factura.serie
        this.factura.numero = this.factura.numero ? this.factura.numero : (+this.serie_factura.ultimo + 1)
        // this.GuardarNumero(this.serie_factura.idnumero,this.serie_factura);
        this.factura.total && this.detfactus.length > 0 ? this.GuardarNumero(this.serie_factura.idnumero, this.serie_factura) : null;
        break;
      default:
        break;
    }
    if (this.factura.tarjeta==='10') {
      this.factura.efectivo=this.factura.total
    }else{
      this.factura.tarjetachq=this.factura.total
    }
  }

  isExpanded(index: number): boolean {
    return this.expandedStates[index];
  }

  toggleAccordion(index: number): void {
    this.expandedStates[index] = !this.expandedStates[index];
    this.toggleIcon(index);
  }

  toggleIcon(index: number): void {
    const icon = this.icons.toArray()[index].nativeElement;
    if (this.expandedStates[index]) {
      icon.classList.add('rotate-180');
    } else {
      icon.classList.remove('rotate-180');
    }
  }


  GuardarDetalle(detalle: any) {
    this.data.Post(this.data.api.detfactura, detalle).subscribe(r => {
    }), e => { };
  }


  EnviarNubefact(faturaid) {
    this.data.GetFromId('data_factura', faturaid).subscribe(r => {
      console.log("Enviando a nubefact");
      console.log(r);
      this.factura.respuesta=JSON.stringify(r);
      this.data.Put(this.data.api.factura,faturaid,this.factura).subscribe(r=>{
        console.log("exito");
      }), e => { console.log(e) }
    }), e => { console.log(e) }
  }

  async GuardarDocumento() {
    this.artloading.show('Cargando datos');
    this.PrepararData();

    if ((this.factura.fecha && this.factura.total && this.factura.apellidos && this.factura.ruc)) {
      const response = await this.data.AsyncPost(this.data.api.factura, this.factura)
      this.detfactus.forEach(detallefactura => {
        detallefactura.idfactura = (response.idfactura).toString();
        console.log("guardando detalles");
        this.GuardarDetalle(detallefactura);
      });

      await new Promise(resolve => setTimeout(resolve, 500)).then(()=>{
        console.log("enviando a nubefact");
        
        this.EnviarNubefact(response.idfactura);
      }
      );
      
      this.artloading.show('hide');
      this.close();
    } else {
      this.data.notify("Datos incompletos.", "Error", this.alertType.error)
    }
  }



  MostrarData() {
    this.PrepararData();
    console.log('mostrando factura');
    console.log(this.factura);
    console.log('mostrando detalles');
    console.log(this.detfactus);
    console.log('mostrando demas');
    console.log(this.cuotas);

  }
}
